import React from "react";

import { useIntl } from "react-intl";

import { Popconfirm } from "@mapmycustomers/ui";

interface DownloadConfirmationProps {
  children: React.ReactNode;
  disabled?: boolean;
  onConfirm: () => void;
}

export const DownloadConfirmation = ({
  children,
  disabled,
  onConfirm,
}: DownloadConfirmationProps) => {
  const intl = useIntl();

  return (
    <Popconfirm
      cancelText={intl.formatMessage({
        id: "dealListModalForCharts.downloadDeals.no",
        defaultMessage: "No",
        description: "Download Cancel button on the list modal",
      })}
      description={intl.formatMessage({
        id: "dealListModalForCharts.downloadDeals.confirm",
        defaultMessage: "Are you sure you want to download this data as a .csv?",
        description: "Download Deals confirm on the list modal",
      })}
      disabled={disabled}
      okText={intl.formatMessage({
        id: "dealListModalForCharts.downloadDeals.yes",
        defaultMessage: "Yes, download",
        description: "Download Confirm button on the list modal",
      })}
      onConfirm={onConfirm}
      placement="topRight"
    >
      {children}
    </Popconfirm>
  );
};
